module.exports = __webpack_public_path__ + "static/media/android.1943111b.png";